export default __webpack_public_path__ + "static/media/marker_media_2.e357313f.svg";